module.exports = __webpack_public_path__ + "img/DManager.a568c75c.svg";